// extracted by mini-css-extract-plugin
module.exports = {"subtitle-wrapper":"LocationAndTime--subtitle-wrapper--XPXfQ","subtitleWrapper":"LocationAndTime--subtitle-wrapper--XPXfQ","location":"LocationAndTime--location--2Uodt"};